import { useRef, useEffect, useState } from "react";

/**
 * Displays a probability percentage with a "price tick" flash effect.
 * Flashes green when the value goes up, red when it goes down,
 * then fades back to the base color after 600ms.
 */
export const TickingPrice = ({
  value,
  baseClassName = "text-foreground",
}: {
  value: number;
  baseClassName?: string;
}) => {
  const prevRef = useRef(value);
  const [flash, setFlash] = useState<"up" | "down" | null>(null);

  useEffect(() => {
    const prev = prevRef.current;
    prevRef.current = value;

    if (value > prev) {
      setFlash("up");
    } else if (value < prev) {
      setFlash("down");
    } else {
      return;
    }

    const timer = setTimeout(() => setFlash(null), 600);
    return () => clearTimeout(timer);
  }, [value]);

  const flashClass =
    flash === "up"
      ? "text-green-400"
      : flash === "down"
        ? "text-red-400"
        : baseClassName;

  return (
    <span
      className={`transition-colors duration-500 ${flashClass}`}
    >
      {value}%
    </span>
  );
};
